import axios from 'axios';
import { localStorageService } from '../services/localStorageService/localStorageService';
import { getAcceptLanguageHeader } from '../common/utils/languageUtils';

const BASE_URL = import.meta.env.VITE_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});
axiosInstance.defaults.withCredentials = true;

axiosInstance.interceptors.request.use((config) => {
  const accessToken = localStorageService().getAccessToken();
  if (config.headers) {
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    config.headers['Accept-Language'] = getAcceptLanguageHeader();
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config.url?.includes('/qrcode/')) {
      return response;
    }
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorageService().removeAccessToken();
      localStorageService().removeRefreshToken();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
